var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoginGuard',[_c('div',{staticClass:"container"},[_c('o-nav-dashboard-menu',{attrs:{"items":_vm.items}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }